import * as React from 'react';
import DefaultButton from '../../../../global/default-button/default-button';
import { useIntl } from 'react-intl';
import Text from '../../../../global/text/text';
import BluePrintItemDetailsPopover from '../../../../_blueprints/blueprint-item-details-popover/blueprint-item-details-popover';
import { useState } from 'react';
import { IBlueprintItemDetails } from '../../../../../api/blueprints/blueprint-details.types';
import { BlueprintType } from '../../../../../api/blueprints/blueprint.types';
import './view-blueprint-details-section.scss';

export interface IViewBlueprintDetailsSectionProps {
    blueprintDetails: IBlueprintItemDetails | null;
    blueprintItemType: BlueprintType;
}

const ViewBlueprintDetailsSection = (props: IViewBlueprintDetailsSectionProps) => {
    const intl = useIntl();
    const {
        blueprintDetails,
        blueprintItemType,
    } = props;
    const [isOpened, setIsOpened] = useState<boolean>(false);
    const openPopUp = () => setIsOpened(true);
    const closePopUp = () => setIsOpened(false);

    const template = isOpened ? blueprintDetails : undefined;

    const blueprintItemLabel = (): string => {
        switch (blueprintItemType) {
            case BlueprintType.MEETING:
                return intl.formatMessage({
                    id: 'oe.viewBlueprintDetailsSection.viewMeetingTemplate',
                    defaultMessage: 'View Meeting Template Details',
                    description: 'Label'
                });
            case BlueprintType.EVENT:
                return intl.formatMessage({
                    id: 'oe.viewBlueprintDetailsSection.viewEventBlueprint',
                    defaultMessage: 'View Event Blueprint Details',
                    description: 'Label'
                });
            case BlueprintType.CONNECTION:
                return intl.formatMessage({
                    id: 'oe.viewBlueprintDetailsSection.viewConnectionBlueprint',
                    defaultMessage: 'View Connection Template Details',
                    description: 'Label'
                });
            case BlueprintType.ORDER:
                return intl.formatMessage({
                    id: 'oe.viewBlueprintDetailsSection.viewOrderTemplate',
                    defaultMessage: 'View Order Template Details',
                    description: 'Label'
                });
        }
    };

    return (
        blueprintDetails &&
        <div className='view-details-area'>
            <Text
                tag='div'
                className='view-details-area__name'
                message={blueprintDetails.name}
                withEllipsis
            />
            <Text
                tag='div'
                className='view-details-area__description'
                message={blueprintDetails.description}
                withEllipsis
            />
            <div>
                <DefaultButton
                    modifier={['slim']}
                    text={blueprintItemLabel()}
                    onClick={openPopUp}
                />
            </div>
            <BluePrintItemDetailsPopover
                title={blueprintItemLabel()}
                template={template}
                closePopover={closePopUp}
            />
        </div>
    );
};

export { ViewBlueprintDetailsSection };

